// extracted by mini-css-extract-plugin
export var buttons = "_50-0";
export var buttonsActive = "_50-h";
export var cancelConfirm = "_50-1";
export var closeButton = "_50-2";
export var column = "_50-3";
export var container = "_50-4";
export var detailHeader = "_50-6";
export var detailTitle = "_50-7";
export var detailsContent = "_50-5";
export var header = "_50-8";
export var headerWithClose = "_50-9";
export var icon = "_50-a";
export var infoIcon = "_50-c";
export var informationContainer = "_50-b";
export var sideDrawer = "_50-d";
export var sideDrawerOpen = "_50-e";
export var stickyFooter = "_50-f";
export var typeOption = "_50-g";